window.VerticalMenu = (function () {

    var selectors = {
        verticalMenu: '#vertical-menu',
        itemsWrapper: '#vm-sports-filter-items'
    };

    return {
        init: function () {
            if (!globalAppSettings.isMobileDevice && globalAppSettings.site !== 'unicom') {
                this.createScrollbar();
            }
        },
        dispose: function () {
            this.removeScrollbar();
        },
        show: function () {
            $(selectors.verticalMenu).removeClass('hidden');
        },
        hide: function () {
            $(selectors.verticalMenu).addClass('hidden');
        },
        createScrollbar: function () {
            var self = this;
            self.scrollbar = new window.AwesomeScrollbar(selectors.itemsWrapper, 'm-sports-filter-scrollbar');
        },
        removeScrollbar: function () {
            var self = this;
            if (self.scrollbar)
                self.scrollbar.destroy();
        },
        changeFavorites: function () {
            $('.sports-filter__sports-icon.m-favorites').addClass('m-animated');
            setTimeout(function () {
                $('.sports-filter__sports-icon.m-favorites').removeClass('m-animated');
            }, 400);
        },
    }
}());